import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';
import { Settings, SettingsGlobal } from './interfaces';

export class SettingsService {
  static prefix = '/Settings';

  public static async getSettings(params: any) {
    try {
      const response: AxiosResponse<Settings[]> = await axios.get(SettingsService.prefix, { params });

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async getSettingsGlobal() {
    try {
      const url = `${SettingsService.prefix}/Global`;
      const response: AxiosResponse<SettingsGlobal> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async putSettingsGlobal(data: FormData) {
    try {
      const url = `${SettingsService.prefix}/Global`;
      const response: AxiosResponse<SettingsGlobal> = await axios.put(url, data);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }
}
